import { useLang } from "@/context/LangContext";
import { ACCOUNT_UI as UI } from "@/data/accountI18n";
import { passwordScore } from "@/lib/passwordStrength";
import { cn } from "@/lib/utils";

const LEVELS = {
  1: { key: "strengthWeak", bar: "bg-destructive", text: "text-destructive" },
  2: { key: "strengthFair", bar: "bg-amber-500", text: "text-amber-600 dark:text-amber-400" },
  3: { key: "strengthGood", bar: "bg-emerald-500", text: "text-emerald-600 dark:text-emerald-400" },
  4: { key: "strengthStrong", bar: "bg-[hsl(var(--gold))]", text: "text-[hsl(var(--gold))]" },
};

// Four-segment strength bar shown under a new-password field (hidden while empty).
export const PasswordStrength = ({ value, "data-testid": testId = "password-strength" }) => {
  const { tc } = useLang();
  const score = passwordScore(value);
  if (!score) return null;
  const lvl = LEVELS[score];
  return (
    <div className="space-y-1.5 pt-1" data-testid={testId} data-score={score}>
      <div className="flex gap-1.5" aria-hidden="true">
        {[1, 2, 3, 4].map((i) => (
          <span key={i} className={cn("h-1.5 flex-1 rounded-full transition-colors duration-300", i <= score ? lvl.bar : "bg-muted")} />
        ))}
      </div>
      <div className="flex items-center justify-between text-xs">
        <span className="text-muted-foreground">{tc(UI.strengthLabel)}</span>
        <span className={cn("font-semibold", lvl.text)} data-testid={`${testId}-label`}>{tc(UI[lvl.key])}</span>
      </div>
      {score < 3 && <p className="text-xs text-muted-foreground leading-relaxed">{tc(UI.strengthTip)}</p>}
    </div>
  );
};
